import { baseConfig } from '../config/algolia';

/**
 * Updates the url parameters used on EPI to the new parameters required to query Algolia.
 * Will only work on collection pages.
 */

export function handleHistoricalUrlParams() {
  const sort = getParameterByName('s');

  if (sort) {
    const sd = getParameterByName('sd');
    const page = getParameterByName('p');
    const sortDirection = sd && sd === '2' ? '_desc' : '_asc';
    let indexSuffix = '';

    switch (sort) {
      case 'displayPrice':
        indexSuffix = `_price${sortDirection}`;
        break;
      case 'releaseDate':
        indexSuffix = `_published_at${sortDirection}`;
        break;
      case 'displayName':
        indexSuffix = `_title${sortDirection}`;
        break;
    }

    // update the url parameters without reloading the page
    setParameterByName('s', '');
    setParameterByName('sd', '');
    setParameterByName('idx', `${baseConfig.index_products}${indexSuffix}`);
    
    if (page) {
      // in EPI page was 1 based, but now in Algolia it is 0 based
      let p = parseInt(page);
      p = p > 0 ? p - 1 : 0;
      setParameterByName('p', p);
    }
  }
};

/**
 * Function used to fetch value from query string.
 * Full details on https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 * @param name
 * @param url
 */
export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Function used to update values in the query string.
 * @param name
 * @param value
 */
const setParameterByName = (name, value) => {
  const url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (results && results[0]) {
    if (value === '') {
      window.history.replaceState({}, document.title, window.location.href.replace(results[0], value));
    } else {
      const separator = results[0].substring(0, 1);
      window.history.replaceState({}, document.title, window.location.href.replace(results[0], `${separator}${name}=${value}`));
    }
  } else {
    if (value) {
      const separator = window.location.href.indexOf('?') > -1 ? '&' : '?';
      window.history.replaceState({}, document.title, window.location.href + `${separator}${name}=${value}`);
    }
  }
}